'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('../../../common/lines/index');

var _index2 = _interopRequireDefault(_index);

var _LinePresentationalWrapper = require('./LinePresentationalWrapper');

var _LinePresentationalWrapper2 = _interopRequireDefault(_LinePresentationalWrapper);

var _LineContainer = require('./LineContainer');

var _LineContainer2 = _interopRequireDefault(_LineContainer);

var _toolbarConstants = require('../../workspace/toolbar/toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = function () {
    return (0, _index2.default)({
        containerComponent: _LineContainer2.default,
        presentationalComponent: _LinePresentationalWrapper2.default,
        tools: [_toolbarConstants.TOOLS.COLOR, _toolbarConstants.TOOLS.START_ARROW, _toolbarConstants.TOOLS.END_ARROW]
    });
};

// Constants


// Components


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/index.js
// module id = 1994
// module chunks = 0